export interface IDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    pureFilters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    populates?: any
    selectedRowKeys?: string[]
    hiddenColumns?: string[]
}

export const initialState: IDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    pureFilters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    populates: [],
    selectedRowKeys: [],
    hiddenColumns: []
}

export const listReducers = {
    onChangePagination(state, acion) {
        state.pagination = { ...state.pagination, ...acion.payload }
    },
    onChangeSelectedRows(state, action) {
        state.selectedRowKeys = action.payload
    },
    onChangeHidedColumns(state, action) {
        state.hiddenColumns = action.payload
    },
    onChangeItem(state, action) {
        state[action.payload.key] = action.payload.value
    },
    onChangeSearch(state, action) {
        state.searchValue = action.payload
    },
    onChangeTotal(state, action) {
        state.pagination = { ...state.pagination, total: action.payload }
    },
    onChangeFilters(state, action) {
        state.filters = action.payload
    },
    onAddFilter(state, action) {
        state.filters = { ...state.filters, ...action.payload }
    },
    onChangePureFilters(state, action) {
        state.pureFilters = action.payload
    },
    onAddPureFilter(state, action) {
        state.pureFilters = { ...state.filters, ...action.payload }
    },
    addPureFilter(state, action) {
        const objectkeys = Object.keys(action.payload)
        for (const key of objectkeys) {
            state.pureFilters[key] = action.payload[key]
        }
    },
    onResetFilters(state) {
        state.filters = {}
        state.pureFilters = {}
    },
    onResetData(state) {
        state.pagination = {
            itemsPerPage: 10,
            currentPage: 1,
            total: 0
        }
        state.searchValue = null
        state.filters = {}
        state.pureFilters = {}
        state.sort = '-createdAt'
    }
}
